var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSmallLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87 2.299a.994.994 0 011.413 0 1.06 1.06 0 010 1.454l-3.876 4 3.876 4a1.06 1.06 0 010 1.454.994.994 0 01-1.413 0L4.295 8.481a1.052 1.052 0 010-1.462z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6228",
    fill: "none",
    d: "M0 0h16v16H0z"
  })));
}
export default SvgArrowSmallLeft;